import {
	EFxIdSdkAdapterInfoSocialCapability,
	FxIdSdkAdapterSocialSettingDefault,
	IExportedFxIdSdkMethod,
	IFxIdSdkAdapterAuthenticateUserRequest,
	IFxIdSdkAdapterAuthenticateUserResponse,
	IFxIdSdkAdapterBuyProductRequest,
	IFxIdSdkAdapterBuyProductResponse,
	IFxIdSdkAdapterInfoSocial,
	IFxIdSdkAdapterSocialSettings,
	IFxIdSdkAdapterStatEventRequest,
	IFxIdSdkInviteFriendsResult
} from "./FxIdSdkBaseAdapter";
import type { CrazyGamesGameSettings, CrazyGamesUser } from "./FxIdSdkBaseAdapter";
import OpenApiClient, { openApiConfig } from "../Api/OpenApiClient";
import {
	FxIdApplicationStoreCreatePaymentHandlerEmbeddingType,
	FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType,
	FxIdDomainStoreEnumsSupportedWebPublishingPlatform,
	FxGamesLibWebPublicDataBase,
	FxIdWebFeaturesStoreCreatePaymentRequest
} from "../Api/gen";
import { getQueriedProfileData } from "../Api/Queries";
import { openLinkShareModal } from "../Components/Modals";
import { FxIdSdkAdapterForFxId } from "./FxIdSdkAdapterForFxId";
import {
	FxIdStats,
	FxIdStatsTutorialCompleted,
	FxIdStatsTutorialSkip,
	FxIdStatsTutorialStart,
	FxIdStatsTutorialStep
} from "./FxIdStats";
import { delayPromise } from "./FxIdSdkUtils";
import vkBridge, { RequestPropsMap } from "@vkontakte/vk-bridge";
import { getAuthToken } from "@app/Api/Auth";
import { IframeType } from "@app/Screens/WebPlayer/Hooks";
import { FxIdDomainModelsDBStoreDBOrderOptimisticUserStatus } from "../Api/gen";
import { errorToString } from "../Utils/Utils";

export class FxIdSdkAdapterForCrazyGames extends FxIdSdkAdapterForFxId {
	readonly adapter: IframeType = "crazygames";

	private currentCGUser?: CrazyGamesUser | null;
	private fxIdStats: FxIdStats;

	constructor(
		protected exportedSdk: IExportedFxIdSdkMethod,
		protected game: string,
		protected config: FxGamesLibWebPublicDataBase
	) {
		super(exportedSdk, game, config);
		this.fxIdStats = new FxIdStats();
	}

	override async RegisterShareHandlers(): Promise<void> {
		// const { enableLinkCopy, enableShareOk, enableShareTelegram, enableShareVk } = sharingHandlersStore.getState();
		// const { enableWebPlayLogin } = appStore.getState();
		// const data = { url: window.location, title: i18next.t(`seo.${this.game}.title`) };
		// enableShareTelegram(() => telegram(data));
		// enableLinkCopy();
		//
		// /*
		//  * TODO: Или переместить в более логичное место или переименовать метод, чтобы можно было подобные подвязыки
		//  * включать туn
		//  */
		// enableWebPlayLogin();
		//
		// const profileData = await getQueriedProfileData();
		//
		// const user: any | null = await window.CrazyGames.SDK.user.getUser();
		// log.info("Get user result", user);
		//
		// const userDisplayName = user?.user ?? profileData.Name ?? profileData.Email ?? `#${profileData.AccountId}`;
		//
		// userStore.getState().updateUserId(String(profileData.AccountId));
		// userStore.getState().updateDisplayName(userDisplayName);
		//
		// return Promise.resolve();
		return Promise.resolve();
	}

	async BuyProduct(request: IFxIdSdkAdapterBuyProductRequest): Promise<IFxIdSdkAdapterBuyProductResponse> {
		const isAvailable = window.CrazyGames.SDK.user.isUserAccountAvailable;

		if (!isAvailable) {
			log.error("User accounts not available");
			return { error: "User accounts not available" };
		}
		let user = await window.CrazyGames.SDK.user.getUser();

		if (user == null) {
			log.warn("User not registered - asking to register");

			try {
				const user = await window.CrazyGames.SDK.user.showAuthPrompt();
				log.info("Auth prompt result", user);
				// window.location.reload();
			} catch (e: any) {
				log.info("Error:", e);
				return { error: e?.message ?? "Error" };
			}
		}

		user = await window.CrazyGames.SDK.user.getUser();

		if (user == null) {
			log.info("User still not registered");
			return { error: "User still not registered" };
		}

		const profileData = await getQueriedProfileData();
		const userToken = await this.GetUserToken();

		if (userToken == null) {
			throw new Error("Failed to get user token");
		}

		const paymentRequest: FxIdWebFeaturesStoreCreatePaymentRequest = {
			Token: getAuthToken()!,
			Game: this.game,
			Sku: request.sku,
			WebPublishingPlatform: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.CrazyGames,
			EmbeddingType: FxIdApplicationStoreCreatePaymentHandlerEmbeddingType.Embed,
			ProductDescriptionHint: request.productDescriptionHint,
			ProductNameHint: request.productNameHint,
			CrazyGames: {
				AccessToken: userToken
			}
		};
		if (request.developerPayload != null) {
			paymentRequest.DeveloperPayload = {
				MerchantDeveloperPayload: request.developerPayload
			};
		}

		const createPaymentResult = await OpenApiClient.Store.fxIdWebFeaturesStoreCreatePaymentEndpoint(paymentRequest);

		log.info("Received result from server: %o", createPaymentResult);

		return this.StartPayment(createPaymentResult);
	}

	/** Собирает общие поля и секцию CrazyGames из одного независимого снимка данных площадки. */
	async GetSocialInfo(): Promise<IFxIdSdkAdapterInfoSocial> {
		const id = await this.CrazyGamesUserId();
		const sdk = window.CrazyGames.SDK;
		// CrazyGames может менять объекты на месте: без копий изменится baseline уже отданного игре social.
		const user = structuredClone(await sdk.user.getUser());
		const settings = structuredClone(sdk.game.settings);
		const environment = sdk.environment;
		const isUserAccountAvailable = sdk.user.isUserAccountAvailable;
		const systemInfo = structuredClone(sdk.user.systemInfo);

		const result: IFxIdSdkAdapterInfoSocial = {
			social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform.CrazyGames,
			paymentsAvailable: true,
			userId: id,
			displayName: user?.username,
			audioMuted: settings.muteAudio,
			crazyGames: { user, settings, environment, isUserAccountAvailable, systemInfo },
			capabilities: [
				EFxIdSdkAdapterInfoSocialCapability.FriendsInvite,
				EFxIdSdkAdapterInfoSocialCapability.GamesOfChanceDisabled,
				EFxIdSdkAdapterInfoSocialCapability.AdsAvailable,
				EFxIdSdkAdapterInfoSocialCapability.InGameNameChangeDisabled
			]
		};

		if (user?.profilePictureUrl != null) {
			result.photo = {
				url: user?.profilePictureUrl
			};
		}

		return result;
	}

	private async CrazyGamesUserId(): Promise<string> {
		const profileData = await getQueriedProfileData();
		const guestId = profileData.SocialIdentifiers.find(
			(el) => el.Type === FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType.CrazyGamesGuest
		);
		const mainId = profileData.SocialIdentifiers.find(
			(el) => el.Type === FxIdDomainModelsDBDBSocialIdentifierSocialIdentifierType.CrazyGames
		);

		if (mainId != null) {
			return mainId.Id;
		} else if (guestId != null) {
			return guestId.Id;
		}
		throw new Error("No registration to crazygames!");
	}

	/** Инициализирует SDK CrazyGames и подписывает адаптер на изменения данных площадки. */
	async Initialize(): Promise<void> {
		await super.Initialize();

		log.info("Initializing CrazyGames");

		// Однажды 2025-04-14 крейзи выкатили кривой сдк.
		const crazyGamesVersionCache = 2;

		await new Promise<void>((resolve) => {
			const s = document.createElement("script");
			s.type = "text/javascript";
			s.src = `https://sdk.crazygames.com/crazygames-sdk-v3.js?cacheVersion=${crazyGamesVersionCache}`;
			s.addEventListener(
				"load",
				function (_e) {
					log.info("Script loaded");
					resolve();
				},
				false
			);
			const head = document.getElementsByTagName("head")[0];
			head.appendChild(s);

			log.info("Script added");
		});

		await window.CrazyGames.SDK.init();
		window.CrazyGames.SDK.game.addSettingsChangeListener(this.OnCrazyGamesSettingsChanged.bind(this));

		const environment: string = await window.CrazyGames.SDK.environment;
		log.info("CrazyGames environment: %o", environment); // 'local', 'crazygames' or 'disabled'

		// CrazyGames попросили что бы это событие вызывала игра когда пользователь уже прямо играет
		// try {
		// 	// window.CrazyGames.SDK.game.gameplayStart(); // result is always undefined for gameplayStart/Stop
		// 	log.info("Gameplay start triggered");
		// } catch (e) {
		// 	log.info("Gameplay start error", e);
		// }

		const isAvailable = window.CrazyGames.SDK.user.isUserAccountAvailable;
		log.info("User account available: %o", isAvailable);

		const systemInfo = window.CrazyGames.SDK.user.systemInfo;
		log.info("Get system info result: %o", systemInfo);

		this.currentCGUser = await window.CrazyGames.SDK.user.getUser();

		log.info("Adding auth listener");
		// add listener
		// https://docs.crazygames.com/sdk/user/html5-v2/#auth-listeners
		window.CrazyGames.SDK.user.addAuthListener(this.CrazyGamesAuthListener.bind(this));

		log.info("Initialized CrazyGames");
	}

	/** Просит SDK перечитать social: сравнение с последним снимком и доставка события выполняются централизованно. */
	OnCrazyGamesSettingsChanged(settings: CrazyGamesGameSettings): void {
		log.info("CrazyGames settings changed: %o", settings);
		this.exportedSdk.DispatchSocialInfoChanged();
	}

	/**
	 * Фидбек от крейзи. Проще говоря когда пользователя не стало надо логаутится полностью и создавать нового гостя
	 *
	 * `When we play as a guest -> make progress -> then log in/register to a fresh account (e.g., account A),
	 * the progress will be carried over to that account, which is good. However, when we logged out immediately,
	 * I found an issue that the game was still logged in with that account A. This issue only happens when the game carries over the guest's progress.
	 * Could you please double-check, and ensure that when a getUser null is detected the game will always start as a guest? Thank you!
	 * @param user
	 * @constructor
	 */
	async CrazyGamesAuthListener(user: CrazyGamesUser | null) {
		log.info("CrazyGames auth listener called with user %o. Current user: %o", user, this.currentCGUser);

		// NOTE: Это конечно же ужасный говнохак. Проблема в том что крейзи шлет авторизацию иногда несколько раз подряд
		while (this.exportedSdk.IsAuthenticationApiInProgress()) {
			log.info("Authentication already in progress. Waiting for it to complete");
			await delayPromise(500);
		}

		const newCrazyGamesAccount = await window.CrazyGames.SDK.user.getUser();

		log.info("Receive user in callback: %o", newCrazyGamesAccount);

		// Был пользователь, а теперь не стало - перезагрузка. После перезагрузки найдется или будет создан гость
		if (this.currentCGUser != null && newCrazyGamesAccount == null) {
			log.info("Had crazygames user account %o, but now user account is not available. Reloading");
			// Сначала логаутимя
			await OpenApiClient.Auth.fxIdWebFeaturesAuthLogoutEndpoint();
			window.location.reload();
			return;
		}

		const token = newCrazyGamesAccount != null ? await this.GetUserToken() : null;

		// Был пользователь, а теперь почему-то токен нулл - не стало. После перезагрузки будет создан гость
		if (this.currentCGUser != null && token == null) {
			log.info("Had user account %o, but now user token is not available. Reloading");
			await OpenApiClient.Auth.fxIdWebFeaturesAuthLogoutEndpoint();
			window.location.reload();
			return;
		}

		if (this.currentCGUser == null && token == null) {
			log.info("Nothing changed. We had no user and have not received token (null). Skipping");
			return;
		}

		log.info("New user token %s. Trying to authenticate", token);

		// Еще разок проверим - не должно быть, но крейзики очень крейзи, а мы "когда-нибудь это перепишем"
		while (this.exportedSdk.IsAuthenticationApiInProgress()) {
			log.info("Authentication already in progress. Waiting for it to complete");
			await delayPromise(500);
		}

		const authenticationResult = await this.exportedSdk.AuthenticateApi({
			Game: this.game,
			Social: FxIdDomainStoreEnumsSupportedWebPublishingPlatform[
				FxIdDomainStoreEnumsSupportedWebPublishingPlatform.CrazyGames
			],
			CrazyGames: {
				Token: token ?? "",
				IsGuest: token == null
			}
		});

		log.info("Authentication result: %o", authenticationResult);

		if (authenticationResult.changeEvent != null) {
			log.info("Account changed. Reloading.");
			await OpenApiClient.Auth.fxIdWebFeaturesAuthLogoutEndpoint();
			window.location.reload();
			return;
		}
	}

	async GetUserToken(): Promise<string | null> {
		try {
			const token = await window.CrazyGames.SDK.user.getUserToken();
			log.info("Get token result", token);
			return token;
		} catch (e) {
			log.info("Error:", e);
		}

		return null;
	}

	override async AdsIsVideoReady(): Promise<boolean> {
		const result = await window.CrazyGames.SDK.ad.hasAdblock();
		log.log("Adblock usage fetched", result);

		return Promise.resolve(!result);
	}

	override AdsShowVideo(): Promise<void> {
		log.info("[VIDEO ADS] Ad requested");
		const callbacks = {
			adFinished: () => {
				log.info("End rewarded ad (callback)");
				window.FxIdSdk!.DispatchAdsFinished();
			},
			adError: (error: unknown, errorData: unknown) => {
				log.info("Error rewarded ad (callback) or not filled. %o. %o", error, errorData);
				window.FxIdSdk!.DispatchAdsFailed();
			},
			adStarted: () => {
				log.info("Start rewarded ad (callback)");
			}
		};

		window.CrazyGames.SDK.ad.requestAd("rewarded", callbacks);

		return Promise.resolve();
	}

	/** Проверяет готовность interstitial-рекламы по отсутствию блокировщика рекламы. */
	override async AdsIsInterstitialReady(): Promise<boolean> {
		const result = await window.CrazyGames.SDK.ad.hasAdblock();
		log.log("Adblock usage fetched", result);

		return Promise.resolve(!result);
	}

	/** Запрашивает interstitial-рекламу и завершает Promise по terminal callback CrazyGames. */
	override AdsShowInterstitial(): Promise<void> {
		log.info("[INTERSTITIAL ADS] Ad requested");

		return new Promise<void>((resolve, reject) => {
			let settled = false;

			// Успешно завершает показ и сохраняет существующее событие только для первого terminal callback.
			const settleFinished = () => {
				if (settled) return;
				settled = true;
				log.info("End interstitial ad (callback)");
				try {
					window.FxIdSdk!.DispatchAdsFinished();
				} catch (error) {
					log.error("Failed to dispatch finished interstitial ad event %o", error);
				} finally {
					resolve();
				}
			};

			// Отклоняет вызов и сохраняет failed-событие только для первого terminal исхода.
			const settleFailed = (error: unknown, errorData: unknown) => {
				if (settled) return;
				settled = true;
				log.error("Error interstitial ad (callback) or not filled. %o. %o", error, errorData);
				const normalizedError = error instanceof Error ? error : new Error(errorToString(error));
				try {
					window.FxIdSdk!.DispatchAdsFailed();
				} catch (dispatchError) {
					log.error("Failed to dispatch failed interstitial ad event %o", dispatchError);
				} finally {
					reject(normalizedError);
				}
			};

			const callbacks = {
				adFinished: settleFinished,
				adError: settleFailed,
				// Начало показа не является terminal-событием и не завершает Promise.
				adStarted: () => {
					log.info("Start interstitial ad (callback)");
				}
			};

			try {
				window.CrazyGames.SDK.ad.requestAd("midgame", callbacks);
			} catch (error) {
				settleFailed(error, undefined);
			}
		});
	}

	override async InviteFriends(): Promise<IFxIdSdkInviteFriendsResult> {
		const profileData = await getQueriedProfileData();

		const link = window.CrazyGames.SDK.game.inviteLink({ roomId: 12345, param2: "value", param3: "value" });
		log.info("Invite link", link);

		// HACK: У нас нет способа забрать из OpenApiClient точный путь до эндпоинта с редиректом, поэтому собираем его
		// руками и надеемся, что все не сломается
		const redirectUrl = new URL(`${openApiConfig.basePath}/api/v1/go`);
		redirectUrl.searchParams.append("fxref", String(profileData.AccountId));
		redirectUrl.searchParams.append("url", link);
		openLinkShareModal({ link: redirectUrl.toString() });
		return { friends: [] };
	}

	async AuthenticateUser(
		request: IFxIdSdkAdapterAuthenticateUserRequest
	): Promise<IFxIdSdkAdapterAuthenticateUserResponse> {
		const isAvailable = window.CrazyGames.SDK.user.isUserAccountAvailable;

		if (!isAvailable) {
			throw new Error("User accounts not available");
		}

		const user = await window.CrazyGames.SDK.user.getUser();

		if (user == null) {
			log.warn("User not registered - asking to register");

			try {
				const user = await window.CrazyGames.SDK.user.showAuthPrompt();
				log.info("Auth prompt result", user);
				// window.location.reload();
				return {};
			} catch (e) {
				log.info("Error:", e);
				throw e;
			}
		} else {
			return {};
		}
	}

	async StatEvent(request: IFxIdSdkAdapterStatEventRequest): Promise<void> {
		const statEvent = this.fxIdStats.ProcessStat(request);
		return Promise.resolve(undefined);
	}

	public async SendCrazyGamesSdk(methodName: string, params?: any) {
		// Split the methodName string to navigate through the SDK object
		const parts = methodName.split(".");
		let currentPart = window.CrazyGames.SDK as any;
		let parent = null; // Initialize a variable to keep track of the parent object

		try {
			// Navigate through the SDK object based on the parts
			for (const part of parts) {
				parent = currentPart; // Update parent to the current object before moving to the next part
				currentPart = currentPart[part];
				if (currentPart === undefined) {
					throw new Error(`Method ${methodName} not found.`);
				}
			}

			// If the last part is a function, call it with the provided params
			if (typeof currentPart === "function") {
				// Bind `this` to the method. Use the parent object as `this` context for the method call
				const methodWithBoundThis = currentPart.bind(parent);
				// Adjust this part if some methods don't return a promise or have different signatures
				return await methodWithBoundThis(params);
			} else {
				throw new Error(`The provided path ${methodName} does not refer to a function.`);
			}
		} catch (error) {
			log.error(error);
			throw error;
		}
	}

	async LoadingReady(): Promise<void> {
		window.CrazyGames.SDK.game.loadingStop();
		void super.LoadingReady();
	}

	async GameStarted(): Promise<void> {
		window.CrazyGames.SDK.game.gameplayStart();
		void super.GameStarted();
	}

	async GameStopped(): Promise<void> {
		window.CrazyGames.SDK.game.gameplayStop();
		void super.GameStopped();
	}
}
